<template>
  <ContainerSmall>
    <img src="/images/Cardstock_Logo.png" class="block mx-auto mt-16 mb-4">
      <div class="text-2xl text-center leading-normal mb-4">
        Logging out...
      </div>
    <div class="text-4xl text-center">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
  </ContainerSmall>
</template>

<script>
import SocketLink     from '@/socketLink.js'

import Cookies        from 'js-cookie'
import ContainerSmall from '@/components/ContainerSmall.vue'

export default {
  components: {
    ContainerSmall
  },

  mounted: function () {
    this.logout()
  },

  methods: {
    logout: function() {
      console.log('Cardstock: beginning logout')

      var self = this

      setTimeout(function () {
        self.$apollo.provider.defaultClient.resetStore()
        localStorage.clear()
        SocketLink.reset()
  
        console.log('Cardstock: logout completed')
  
        window.location.replace('/')
      }, 1000)
    }
  }
}
</script>
